import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiFileText } = FiIcons;

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-[#fafafa] pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link to="/" className="inline-flex items-center gap-2 text-emerald-700 font-bold mb-12 hover:gap-3 transition-all">
          <SafeIcon icon={FiArrowLeft} /> Back to Home
        </Link>
        
        <div className="glass-card rounded-[3rem] p-10 md:p-16 shadow-2xl border-white/40">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-emerald-100 rounded-2xl flex items-center justify-center text-emerald-700">
              <SafeIcon icon={FiFileText} className="text-2xl" />
            </div>
            <h1 className="text-4xl font-extrabold text-emerald-900">SMS Terms & Conditions</h1>
          </div>

          <div className="prose prose-emerald max-w-none space-y-8 text-gray-600 leading-relaxed">
            <p>By opting in, you agree to receive recurring automated marketing and informational text messages from Quant Asset Partners LLC regarding vacant land purchase offers and off-market inquiries.</p>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">1. Program Description</h2>
              <p>Messages may include direct cash offers for your property, follow-up inquiries, and transaction updates. Consent is not a condition of any purchase or sale.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">2. Message Frequency</h2>
              <p>Message frequency varies based on your interest in selling your property but will generally not exceed 4 messages per month.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">3. Cost</h2>
              <p>We do not charge for this service, but message and data rates may apply from your mobile carrier.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-emerald-900 mb-4">4. Opt-Out & Help</h2>
              <p>To stop receiving messages, reply STOP at any time. For assistance, reply HELP or contact <a href="mailto:acquisitions@quantassetpartners.com" className="text-emerald-700 font-bold underline">acquisitions@quantassetpartners.com</a>.</p>
            </section>

            <section className="bg-red-50 p-8 rounded-3xl border border-red-100">
              <h2 className="text-2xl font-bold text-red-900 mb-4">5. Limitation of Liability</h2>
              <p className="text-red-800">Carriers and Quant Asset Partners LLC are not liable for delayed or undelivered messages.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}